import { FC } from "react";
import { LoadingProgress } from "@/ui";
import styles from "./OrderPaneLoading.module.scss";

/** Shared loading block for order detail panes (Customers-style). */
export const OrderPaneLoading: FC = () => (
    <div className={styles.loading}>
        <LoadingProgress
            indeterminate
            indicator="circular"
            size="sm"
            title="Loading"
        />
    </div>
);

export default OrderPaneLoading;
